import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PageHeader from '../components/PageHeader';

const categories = [
  { icon: 'fa-laptop-code',      label: 'Technology',         count: 245, color: '#0066FF', bg: '#e8f0ff', trending: true,  desc: 'Software, Web, Mobile & IT' },
  { icon: 'fa-mail-bulk',        label: 'Marketing',          count: 123, color: '#ef4444', bg: '#fff0f0', trending: true,  desc: 'Digital, Content & Brand' },
  { icon: 'fa-drafting-compass', label: 'Design & Creative',  count: 145, color: '#ec4899', bg: '#fdf0f7', trending: false, desc: 'UI/UX, Graphic & Motion' },
  { icon: 'fa-chart-line',       label: 'Business Dev',       count: 89,  color: '#f59e0b', bg: '#fff8e6', trending: false, desc: 'Strategy, Sales & Growth' },
  { icon: 'fa-headset',          label: 'Customer Service',   count: 98,  color: '#06b6d4', bg: '#e0f9ff', trending: false, desc: 'Support, CRM & Success' },
  { icon: 'fa-user-tie',         label: 'Human Resources',    count: 76,  color: '#00C896', bg: '#e6fff6', trending: true,  desc: 'Recruiting, L&D & Culture' },
  { icon: 'fa-tasks',            label: 'Project Management', count: 54,  color: '#8b5cf6', bg: '#f3eeff', trending: false, desc: 'Agile, Scrum & Delivery' },
  { icon: 'fa-hands-helping',    label: 'Sales',              count: 112, color: '#f97316', bg: '#fff4ed', trending: true,  desc: 'B2B, B2C & Account Mgmt' },
  { icon: 'fa-book-reader',      label: 'Education',          count: 67,  color: '#10b981', bg: '#ecfdf5', trending: false, desc: 'Teaching, Training & eLearning' },
  { icon: 'fa-heartbeat',        label: 'Healthcare',         count: 91,  color: '#ef4444', bg: '#fff0f0', trending: true,  desc: 'Medical, Nursing & Pharma' },
  { icon: 'fa-balance-scale',    label: 'Legal',              count: 38,  color: '#6366f1', bg: '#eef2ff', trending: false, desc: 'Law, Compliance & IP' },
  { icon: 'fa-dollar-sign',      label: 'Finance',            count: 103, color: '#0066FF', bg: '#e8f0ff', trending: false, desc: 'Accounting, Banking & FinTech' },
];

const stats = [
  { num: '12+',    label: 'Job Categories',  icon: 'fa-th-large',   color: '#0066FF', bg: '#e8f0ff' },
  { num: '1,200+', label: 'Active Jobs',     icon: 'fa-briefcase',  color: '#00C896', bg: '#e6fff6' },
  { num: '8K+',    label: 'Companies',       icon: 'fa-building',   color: '#f59e0b', bg: '#fff8e6' },
  { num: '120K+',  label: 'Job Seekers',     icon: 'fa-users',      color: '#8b5cf6', bg: '#f3eeff' },
];

export default function Category() {
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('all');
  const navigate = useNavigate();

  const filtered = categories.filter(c =>
    c.label.toLowerCase().includes(search.toLowerCase()) &&
    (filter === 'all' || (filter === 'trending' && c.trending))
  );

  const handleCategoryClick = (label) => {
    navigate(`/job-list?category=${encodeURIComponent(label)}`);
  };

  return (
    <>
      <PageHeader title="Job Categories" breadcrumb="Categories" />

      {/* Stats */}
      <section style={{ background: '#fff', borderBottom: '1px solid #f0f0f0', padding: '32px 0' }}>
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 24 }} className="cat-stats-grid">
            {stats.map((s, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 16, padding: '20px 24px', background: '#fafbff', borderRadius: 16, border: '1.5px solid #eef0f8' }}>
                <div style={{ width: 52, height: 52, borderRadius: 14, background: s.bg, color: s.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, flexShrink: 0 }}>
                  <i className={`fa ${s.icon}`}></i>
                </div>
                <div>
                  <div style={{ fontSize: 24, fontWeight: 800, color: '#0A1628', lineHeight: 1 }}>{s.num}</div>
                  <div style={{ fontSize: 13, color: '#888', marginTop: 4 }}>{s.label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Search & Filter */}
      <section className="section-pad pb-0">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">Explore Fields</span>
            <h2 className="section-title">Browse All Job Categories</h2>
            <p className="section-sub">Find the perfect opportunity in your area of expertise</p>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 40, flexWrap: 'wrap' }}>
            <div style={{ flex: 1, minWidth: 260, display: 'flex', alignItems: 'center', gap: 10, background: '#fff', border: '1.5px solid #eef0f8', borderRadius: 12, padding: '12px 18px', boxShadow: '0 2px 12px rgba(0,0,0,0.04)' }}>
              <i className="fa fa-search" style={{ color: '#aaa' }}></i>
              <input
                type="text"
                placeholder="Search categories..."
                value={search}
                onChange={e => setSearch(e.target.value)}
                style={{ border: 'none', outline: 'none', fontSize: 14, width: '100%', background: 'transparent' }}
              />
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              {['all', 'trending'].map(f => (
                <button
                  key={f}
                  onClick={() => setFilter(f)}
                  style={{
                    padding: '11px 22px', borderRadius: 10, fontSize: 13, fontWeight: 600, cursor: 'pointer', border: 'none', transition: 'all .2s',
                    background: filter === f ? '#0066FF' : '#fff',
                    color: filter === f ? '#fff' : '#555',
                    boxShadow: filter === f ? '0 4px 14px rgba(0,102,255,0.3)' : '0 2px 8px rgba(0,0,0,0.06)',
                  }}
                >
                  {f === 'trending' && <i className="fa fa-fire me-2" style={{ color: filter === 'trending' ? '#fff' : '#f97316' }}></i>}
                  {f === 'all' ? 'All Categories' : 'Trending'}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Category Grid */}
      <section className="section-pad" style={{ paddingTop: 24 }}>
        <div className="container">
          {filtered.length === 0 ? (
            <div className="jl-empty">
              <i className="fa fa-search"></i>
              <h5>No categories found</h5>
              <p>Try a different search term</p>
            </div>
          ) : (
            <div className="cat-pro-grid">
              {filtered.map((cat, i) => (
                <div
                  key={i}
                  onClick={() => handleCategoryClick(cat.label)}
                  style={{ cursor: 'pointer' }}
                  className="cat-pro-card-new"
                >
                  {cat.trending && (
                    <span style={{ position: 'absolute', top: 14, right: 14, background: 'linear-gradient(135deg,#ff6b35,#f59e0b)', color: '#fff', fontSize: 10, fontWeight: 700, padding: '3px 10px', borderRadius: 50 }}>
                      🔥 Trending
                    </span>
                  )}
                  <div style={{ width: 58, height: 58, borderRadius: 16, background: cat.bg, color: cat.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24, marginBottom: 16, transition: 'transform .25s' }} className="cat-icon-wrap">
                    <i className={`fa ${cat.icon}`}></i>
                  </div>
                  <h5 style={{ fontSize: 15, fontWeight: 700, color: '#0A1628', margin: '0 0 6px' }}>{cat.label}</h5>
                  <p style={{ fontSize: 12, color: '#999', margin: '0 0 18px', lineHeight: 1.5 }}>{cat.desc}</p>
                  <div style={{ marginTop: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingTop: 14, borderTop: '1px solid #f5f5f5' }}>
                    <span style={{ fontSize: 12, fontWeight: 700, padding: '4px 12px', borderRadius: 50, background: cat.bg, color: cat.color }}>
                      {cat.count} Jobs
                    </span>
                    <span style={{ width: 30, height: 30, borderRadius: 8, background: cat.bg, color: cat.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, transition: 'transform .2s' }} className="cat-arrow-wrap">
                      <i className="fa fa-arrow-right"></i>
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Why Browse */}
      <section className="section-pad" style={{ background: '#f8faff' }}>
        <div className="container">
          <div className="section-header">
            <span className="section-badge">Why JustHiring24</span>
            <h2 className="section-title">Find Jobs the Smarter Way</h2>
            <p className="section-sub">Browse by category to discover roles that match your skills and passion</p>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 24 }} className="cat-why-grid">
            {[
              { icon: 'fa-bolt',       color: '#0066FF', bg: '#e8f0ff', title: 'AI-Powered Matching',    desc: 'Smart algorithm matches you with the most relevant jobs instantly.' },
              { icon: 'fa-shield-alt', color: '#00C896', bg: '#e6fff6', title: 'Verified Listings Only', desc: 'Every listing is verified by our team to ensure quality and legitimacy.' },
              { icon: 'fa-bell',       color: '#f59e0b', bg: '#fff8e6', title: 'Instant Job Alerts',     desc: 'Get notified the moment a new job is posted in your preferred category.' },
              { icon: 'fa-chart-line', color: '#8b5cf6', bg: '#f3eeff', title: 'Career Insights',        desc: 'Access salary data, growth trends and demand insights for every category.' },
            ].map((w, i) => (
              <div key={i} style={{ background: '#fff', borderRadius: 20, padding: '28px 24px', border: '1.5px solid #eef0f8', boxShadow: '0 4px 20px rgba(0,0,0,0.04)', textAlign: 'center', transition: 'all .25s' }} className="cat-why-card">
                <div style={{ width: 60, height: 60, borderRadius: 16, background: w.bg, color: w.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, margin: '0 auto 16px' }}>
                  <i className={`fa ${w.icon}`}></i>
                </div>
                <h6 style={{ fontSize: 15, fontWeight: 700, color: '#0A1628', marginBottom: 10 }}>{w.title}</h6>
                <p style={{ fontSize: 13, color: '#888', lineHeight: 1.7, margin: 0 }}>{w.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-card">
            <div className="cta-left">
              <h2>Can't Find Your Category?</h2>
              <p>Browse all jobs or contact us and we'll help you find the right role.</p>
            </div>
            <div className="cta-right">
              <Link to="/job-list" className="cta-btn-white">Browse All Jobs</Link>
              <Link to="/contact" className="cta-btn-outline">Contact Us</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
